import { proxy } from 'valtio';

export const uiStore = proxy({
  // Sidebar state
  sidebarOpen: true,
  isMobile: false,
  
  // Loading state
  loading: false,
  loadingMessage: '',
  
  // Breadcrumbs
  breadcrumbs: [],
  
  // Modal state
  modals: {},
  
  // Actions
  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  },
  
  setSidebarOpen(isOpen) {
    this.sidebarOpen = isOpen;
  },
  
  setLoading(isLoading, message = '') {
    this.loading = isLoading;
    this.loadingMessage = message;
  },
  
  setBreadcrumbs(breadcrumbs) {
    this.breadcrumbs = Array.isArray(breadcrumbs) ? breadcrumbs : [];
  },
  
  openModal(modalName, props = {}) {
    this.modals = {
      ...this.modals,
      [modalName]: { isOpen: true, ...props }
    };
  },
  
  closeModal(modalName) {
    if (this.modals[modalName]) {
      this.modals[modalName].isOpen = false;
    }
  },
  
  // Check if mobile
  checkIsMobile() {
    this.isMobile = window.innerWidth < 768;
    
    // Close sidebar on mobile by default
    if (this.isMobile) {
      this.sidebarOpen = false;
    }
  }
});

// Initialize mobile detection
if (typeof window !== 'undefined') {
  uiStore.checkIsMobile();
  
  // Update on resize
  window.addEventListener('resize', () => {
    uiStore.checkIsMobile();  
  });
}
